 /* istanbul ignore next */
/// <reference types="jquery" />
/// <reference types="bootstrap" />

// DSS Documentation on SocoModalComponent - http://tiny.sc/cgsocomodalcomponent
// DSS Documentation on SocoModalService - http://tiny.sc/cgsocomodalservice
import { Component } from '@angular/core';
import { SocoModalService, SocoModalServiceOptions, SocoModalType } from '@app/soco/modal/soco-modal.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'soco-modal',
    template: `
        <div id="soco-modal" class="modal fade" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content">
            <div class="modal-header {{headerCssClass}}">
                <button type="button" class="close" *ngIf="!isStatic" (click)="confirmationChoice(false)">×</button>
                <h6 class="modal-title">
                    <i *ngIf="headerIcon" class="{{headerIcon}}"></i>
                    <span>{{title}}</span>
                </h6>
            </div>

            <div class="modal-body" [innerHtml]="body">
            </div>
            <div class="modal-footer" *ngIf="!isStatic">
                <div *ngIf="!isConfirmationModal">
                    <button class="btn btn-link" id="btnModal"  data-dismiss="modal">{{okButton}}</button>
                </div>
                <div *ngIf="isConfirmationModal">
                    <button class="btn btn-default" (click)="confirmationChoice(false)">{{cancelButton}}</button>
                    <button class="btn {{buttonCssClass}}" id="btnModal" (click)="confirmationChoice(true)">{{confirmButton}}</button>
                </div>
            </div>
            </div>
        </div>
        </div>`
})

export class SocoModalComponent {
    /* istanbul ignore next */
    title: string = null;
    isConfirmationModal = false;
    isModal = false;
    isStatic = false;
    headerIcon: string = null;
    headerCssClass = '';
    buttonCssClass = '';
    okButton = 'Ok';
    cancelButton = 'No';
    confirmButton = 'Yes';
    body: SafeHtml = null;
    dontCloseOnChoice = false;
    // callback: (choice: boolean) => void = null; // upgraded to use Observable

    /* istanbul ignore next */
    constructor(private socoModalService: SocoModalService, private sanitizer: DomSanitizer) {
        socoModalService.modalShown$.subscribe(options => {
            this.show(options);
        });
        socoModalService.modalHidden$.subscribe(shouldFade => {
            this.hide(shouldFade);
        });
    }

    /* istanbul ignore next */
    confirmationChoice(choice: boolean): void {
        this.socoModalService.setModalChoice(choice);
        if (!this.dontCloseOnChoice) { this.hide(true); }
    }

    /* istanbul ignore next */
    private show(options: SocoModalServiceOptions): void {
        // set all of the variables
        this.title = options.title;
        this.body = this.sanitizer.bypassSecurityTrustHtml(options.body);
        this.isConfirmationModal = options.isConfirmationModal;
        this.isModal = options.isModal;
        this.headerCssClass = options.headerCssClass ? options.headerCssClass : '';
        this.buttonCssClass = options.buttonCssClass ? options.buttonCssClass : '';
        this.okButton = options.okButton ? options.okButton : 'Ok';
        this.cancelButton = options.cancelButton ? options.cancelButton : 'No';
        this.confirmButton = options.confirmButton ? options.confirmButton : 'Yes';
        this.isStatic = options.isStatic;
        this.dontCloseOnChoice = options.dontCloseOnChoice;
        switch (options.type) {
            case SocoModalType.Error:
                this.headerIcon = 'icon-cancel-circle2 position-left';
                break;
            case SocoModalType.Failure:
                this.headerIcon = 'icon-warning2 position-left';
                break;
            case SocoModalType.Caution:
                this.headerIcon = 'icon-help position-left';
                break;
            case SocoModalType.Information:
                this.headerIcon = 'icon-info22 position-left';
                break;
            case SocoModalType.Success:
                this.headerIcon = 'icon-checkmark-circle position-left';
                break;
            default:
                this.headerIcon = null;
                break;
        }
         /* istanbul ignore next */
        // configure the backdrop
        const modal = $('#soco-modal').data('bs.modal');
        if (modal) {
            modal.options.backdrop = options.isModal ? 'static' : true;
            $('#soco-modal').data('bs.modal', modal);

            // show the modal
            $('#soco-modal').modal('show');
        } else {
            // show the modal using options
            $('#soco-modal').modal({
                backdrop: options.isModal ? 'static' : true,
                show: true
            });

            $('#soco-modal').modal('show');
        }
        $('#soco-modal').on('shown.bs.modal', function(event) {
          // not setting focus to submit button
          $('#btnModal').focus();
      });

    $(window).on('hashchange', function (event) {
          window.history.go(-1);
    });

    }
     /* istanbul ignore next */
    private hide(shouldFade: boolean): void {
        // reset the backdrop
        const modal = $('#soco-modal').data('bs.modal');
        if (modal) {
            modal.options.backdrop = true;
            $('#soco-modal').data('bs.modal', modal);
        }

        // hide the modal
        if (shouldFade) {
            $('#soco-modal').modal('hide');
        } else {
            $('#soco-modal').removeClass('fade').modal('hide');
            $('#soco-modal').addClass('fade');
        }
    }
}
